<ng-container *ngFlag="'notes'">
  <app-collapse-box
    [heading]="heading"
    [isFromLead]="true"
    [AddNew]="false"
    [isCollapsed]="isCollapsed"
    helpTarget="lead-detail-report-notes-summary">
    <ng-container *ngIf="isLeadEdit; else viewModeSummary">
      <div class="summary-actions d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
        <div class="summary-source-indicator" *ngIf="summarySource">
          <span
            class="summary-source-badge"
            [class.summary-source-badge--ai]="summarySource === 'ai'"
            [class.summary-source-badge--manual]="summarySource === 'manual'"
            [title]="
              isAutoUpdatePaused
                ? 'Auto-update is paused while you edit manually. Use Regenerate AI Summary to refresh from AI.'
                : 'This summary was generated by AI and will update when report notes or inspection details change.'
            ">
            <i class="pi" [ngClass]="summarySource === 'ai' ? 'pi-sparkles' : 'pi-pencil'"></i>
            {{ summarySource === 'ai' ? 'AI Generated' : 'Manually Edited' }}
          </span>
          <span class="summary-source-hint" *ngIf="isAutoUpdatePaused">Auto-update paused</span>
        </div>
        <button type="button" class="_outline-btn ms-auto" [disabled]="isGeneratingSummary || !leadId" (click)="requestAiSummary()">
          {{ isGeneratingSummary ? 'Generating…' : summaryValue ? 'Regenerate AI Summary' : 'Generate AI Summary' }}
        </button>
      </div>
      <textarea
        class="summary-editor"
        pInputTextarea
        spellcheck="true"
        autoresize="autoResize"
        (input)="onSummaryManualEdit()"
        [formControl]="editLeadForm.controls['report_notes_summary']">
      </textarea>
    </ng-container>
    <ng-template #viewModeSummary>
      <div class="summary-source-indicator mb-2" *ngIf="summarySource">
        <span
          class="summary-source-badge"
          [class.summary-source-badge--ai]="summarySource === 'ai'"
          [class.summary-source-badge--manual]="summarySource === 'manual'">
          <i class="pi" [ngClass]="summarySource === 'ai' ? 'pi-sparkles' : 'pi-pencil'"></i>
          {{ summarySource === 'ai' ? 'AI Generated' : 'Manually Edited' }}
        </span>
      </div>
      <div class="d-flex align-items-start gap-2 mb-3" *ngIf="error_message">
        <i class="pi pi-exclamation-triangle f-10 _fw-400 text-danger"></i>
        <p class="text-danger f-10 _fw-400">{{ error_message }}</p>
      </div>
      <div class="paragraph-style">{{ summaryValue }}</div>
    </ng-template>
  </app-collapse-box>
</ng-container>
